import UTCDateTime from '@/lib/utc-datetime'
import { aidTaskRecordAverageSpeed, aidTaskRecordWorkWidth } from '@/lib/filters'
import axios from 'axios'
import { getSpeedTextFrom } from '@/lib/system-of-units'
import GrowCrop from '@/lib/grow-crop'
import connectGrowClient from '@/lib/connect-client/connect-grow-client'
import SoilMoisture from '@/lib/grow/soil-moisture'
import AccumulatedTemperature from '@/lib/grow/accumulated-temperature'
import * as Types from '../mutation-types'
import geohash from 'ngeohash'
import moment from 'moment'
import UserInfo from '@/lib/user-info'
import ApplicationConfig from '@/lib/application-config'

const state = {
  growPredictions: [],
  growCrops: [],

  growWeatherApiCalling: false,
  growSoilMoistures: [],
  growSoilMoisturesFromOpenMeteo: [],
  growAccumulatedTemperatures: [],
  growAtFromOpenMeteo: [],
}

const getters = {
  growPredictions: state => state.growPredictions,
  growCrops: state => state.growCrops,

  growSoilMoistures: state => state.growSoilMoistures,
  growSoilMoisturesFromOpenMeteo: state => state.growSoilMoisturesFromOpenMeteo,
  growAccumulatedTemperatures: state => state.growAccumulatedTemperatures,
  growAtFromOpenMeteo: state => state.growAtFromOpenMeteo,
}

const mutations = {
  [Types.GROW_SET_GROW_PREDICTIONS](state, predictions) {
    state.growPredictions = predictions
  },

  [Types.GROW_SET_GROW_CROPS](state, crops) {
    state.growCrops = crops.map(crop => new GrowCrop(crop))
  },

  // 2024.01.24 OpenMeteo対応により廃止
  // @Deprecated
  [Types.GROW_PUT_SOIL_MOISTURE](state, soilMoisture) {
    const oid = soilMoisture.observationId
    let index = state.growSoilMoistures.findIndex(sm => sm.observationId === oid)
    if (index < 0) {
      state.growSoilMoistures.push(soilMoisture)
    } else {
      // 配列の要素を入れ替える場合、spliceで置き換えないとリアクティブにならない
      // https://ti-tomo-knowledge.hatenablog.com/entry/2018/07/10/110003
      state.growSoilMoistures.splice(index, 1, soilMoisture)
    }
  },

  [Types.GROW_PUT_SOIL_MOISTURE_FROM_OPEN_METEO](state, soilMoisture) {
    const oid = soilMoisture.observationId
    let index = state.growSoilMoisturesFromOpenMeteo.findIndex(sm => sm.observationId === oid)
    if (index < 0) {
      state.growSoilMoisturesFromOpenMeteo.push(soilMoisture)
    } else {
      // 配列の要素を入れ替える場合、spliceで置き換えないとリアクティブにならない
      // https://ti-tomo-knowledge.hatenablog.com/entry/2018/07/10/110003
      state.growSoilMoisturesFromOpenMeteo.splice(index, 1, soilMoisture)
    }
  },

  // 2024.01.24 OpenMeteo対応により廃止
  // @Deprecated
  [Types.GROW_PUT_ACCUMULATED_TEMPERATURE](state, accTemp) {
    const oid = accTemp.observationId
    let index = state.growAccumulatedTemperatures.findIndex(sm => sm.observationId === oid)
    if (index < 0) {
      state.growAccumulatedTemperatures.push(accTemp)
    } else {
      // 配列の要素を入れ替える場合、spliceで置き換えないとリアクティブにならない
      // https://ti-tomo-knowledge.hatenablog.com/entry/2018/07/10/110003
      state.growAccumulatedTemperatures.splice(index, 1, accTemp)
    }
  },

  [Types.GROW_PUT_ACCUMULATED_TEMPERATURE_FROM_OPEN_METEO](state, accTemp) {
    const oid = accTemp.observationId
    let index = state.growAtFromOpenMeteo.findIndex(sm => sm.observationId === oid)
    if (index < 0) {
      state.growAtFromOpenMeteo.push(accTemp)
    } else {
      // 配列の要素を入れ替える場合、spliceで置き換えないとリアクティブにならない
      // https://ti-tomo-knowledge.hatenablog.com/entry/2018/07/10/110003
      state.growAtFromOpenMeteo.splice(index, 1, accTemp)
    }
  },
}

const actions = {
  // FIXME 仮実装
  predictOperation({ commit }, params) {
    const task = params.taskRecordItem
    const date = UTCDateTime.toYearMonthDay(task.createdDateTime).replaceAll('/', '-')
    const width = aidTaskRecordWorkWidth(task)
    let speed = params.effectiveSpeed
    if (speed <= 0) {
      speed = aidTaskRecordAverageSpeed(task)
      speed = getSpeedTextFrom(speed).replaceAll(' km/h', '')
    }

    let apiUrl =
      'https://sakumotsu-api.herokuapp.com/v1/shirahata/simple?date=' +
      date +
      '&work_width=' +
      width +
      '&speed=' +
      speed
    const crop = params.crop
    if (crop >= 0) {
      apiUrl += '&crop=' + crop
    }
    axios.get(apiUrl).then(response => {
// TEMP       console.log(response.data)
      commit(Types.GROW_SET_GROW_PREDICTIONS, response.data)
    })
  },

  // FIXME 仮実装
  initGrowCrops({ commit }, params) {
    let apiUrl = 'https://sakumotsu-api.herokuapp.com/v1/crops?lat=' + params.lat + '&lon=' + params.lon
    axios.get(apiUrl).then(response => {
      commit(Types.GROW_SET_GROW_CROPS, response.data)
    })
  },

  // 2024.01.24 OpenMeteo対応により廃止
  // @Deprecated
  growGetSoilMoisture({ commit }, observation) {
    connectGrowClient
      .getSoilMoisture(observation)
      .then(response => {
        const soilMoisture = SoilMoisture.fromApiResponse(response.data, observation)
        commit(Types.GROW_PUT_SOIL_MOISTURE, soilMoisture)
      })
      .catch(error => {
        // FIXME 取得失敗オブジェクトを挿入
        console.error(error)
      })
  },

  // 2024.01.24 IBMよりOpenMeteoからデータ取得する方針に変更
  growGetSoilMoistureFromOpenMeteo({ commit }, observation) {
    const bounds = geohash.decode_bbox(observation.geohash)
    const latCenter = (bounds[0] + bounds[2]) / 2
    const lonCenter = (bounds[1] + bounds[3]) / 2

    const endDt = moment()
      .add(7, 'days')
      .format('YYYY-MM-DD')
    const startDt = moment()
      .subtract(7, 'days')
      .format('YYYY-MM-DD')

    // https://open-meteo.com/en/docs
    let apiUrl =
      'https://api.open-meteo.com/v1/forecast?latitude=' +
      latCenter +
      '&longitude=' +
      lonCenter +
      '&start_date=' +
      startDt +
      '&end_date=' +
      endDt +
      '&hourly=precipitation,soil_temperature_6cm,soil_moisture_1_to_3cm,soil_moisture_3_to_9cm'
    axios
      .get(apiUrl)
      .then(response => {
        const times = response.data.hourly.time
        const soil_moisture_3_to_9cm = response.data.hourly.soil_moisture_3_to_9cm

        const now = moment().format('YYYY-MM-DD')
        let index = 0
        let soil_moisture_3_to_9cmAll = 0
        for (let time of times) {
          // timeが当日だったらsoil_moisture_3_to_9cmを足していく
          if (now === moment(time).format('YYYY-MM-DD')) {
            soil_moisture_3_to_9cmAll += soil_moisture_3_to_9cm[index]
          }
          index++
        }
        // 24h分の平均値を算出
        soil_moisture_3_to_9cmAll = soil_moisture_3_to_9cmAll / 24

        // 土の状態の閾値
        const Soil = {
          SandyLoam: { maxThreshold: 0.35, minThreshold: 0.15 },
          ClayLoam: { maxThreshold: 0.4, minThreshold: 0.25 },
          Clay: { maxThreshold: 0.45, minThreshold: 0.25 },
        }
        const soilValue = Soil[observation.soil]
        // soil_moisture_3_to_9cmAllが閾値を超えているか判定
        let soilMoistureValue = null

        if (soil_moisture_3_to_9cmAll < soilValue.minThreshold) {
          soilMoistureValue = 'Dry'
        }
        if (soil_moisture_3_to_9cmAll > soilValue.minThreshold && soil_moisture_3_to_9cmAll < soilValue.maxThreshold) {
          soilMoistureValue = 'Wet'
        }
        if (soil_moisture_3_to_9cmAll > soilValue.maxThreshold) {
          soilMoistureValue = 'VeryWet'
        }

        const soilMoisture = SoilMoisture.fromApiResponseOpenMeteo(soilMoistureValue)
        const lang = UserInfo.getLanguage()
        const result = {
          observationId: observation.id,
          observedList: response.data.hourly,
          soilMoisture: soilMoisture,
          date: moment()
            .locale(lang)
            .format('ll'),
        }
        commit(Types.GROW_PUT_SOIL_MOISTURE_FROM_OPEN_METEO, result)
      })
      .catch(error => {
        // FIXME 取得失敗オブジェクトを挿入
        console.error(error)
      })
  },

  // 2024.01.24 OpenMeteo対応により廃止
  // @Deprecated
  growGetAccumulatedTemperature({ commit }, observation) {
    connectGrowClient
      .getAccumulatedTemperature(observation)
      .then(response => {
        const at = AccumulatedTemperature.fromApiResponse(response.data, observation)
        commit(Types.GROW_PUT_ACCUMULATED_TEMPERATURE, at)
      })
      .catch(error => {
        // FIXME 取得失敗オブジェクトを挿入
        console.error(error)
      })
  },

  // 2024.01.24 IBMよりOpenMeteoからデータ取得する方針に変更
  growGetAtFromOpenMeteo({ commit }, observation) {
    const bounds = geohash.decode_bbox(observation.geohash)
    const latCenter = (bounds[0] + bounds[2]) / 2
    const lonCenter = (bounds[1] + bounds[3]) / 2

    const startDt = observation.startDate
    let endDt = observation.endDate

    if (!endDt) {
      endDt = moment().format('YYYY-MM-DD')
    }

    // https://api.open-meteo.com/v1/forecast?latitude=52.52&longitude=13.41&daily=temperature_2m_max,temperature_2m_min&start_date=2023-11-01&end_date=2023-11-20
    let apiUrl =
      'https://api.open-meteo.com/v1/forecast?latitude=' +
      latCenter +
      '&longitude=' +
      lonCenter +
      '&start_date=' +
      startDt +
      '&end_date=' +
      endDt +
      '&daily=temperature_2m_max,temperature_2m_min'
    axios
      .get(apiUrl)
      .then(response => {
        const times = response.data.daily.time
        const temperature_2m_max = response.data.daily.temperature_2m_max
        const temperature_2m_min = response.data.daily.temperature_2m_min
        let index = 0
        let sum = 0
        for (let time of times) {
          // 最大と最小の平均値を算出
          let average = (temperature_2m_max[index] + temperature_2m_min[index]) / 2
          if (average > observation.lowerLimitTemperature) {
            average = average - observation.lowerLimitTemperature
          } else {
            average = 0
          }
          sum += average
          index++
        }
        const result = {
          observationId: observation.id,
          roundedTemperature: sum,
          observedList: response.data.daily,
        }
        commit(Types.GROW_PUT_ACCUMULATED_TEMPERATURE_FROM_OPEN_METEO, result)
      })
      .catch(error => {
        // FIXME 取得失敗オブジェクトを挿入
        console.error(error)
      })
  },

  growGetWeatherInfoOfField({ commit }, params) {
    const field = params.field
    const startMomentUtc = UTCDateTime.toUtcMoment(params.dateTime)
    const centroid = field.centroid
    const latLon = { latitude: null, longitude: null }
    if (centroid) {
      latLon.latitude = centroid.coordinates[1]
      latLon.longitude = centroid.coordinates[0]
    }

    if (ApplicationConfig.OPEN_METEO_ENABLED) {
      const startDt = startMomentUtc.format('YYYY-MM-DD')
      // 直近だとhttps://api.open-meteo.com/v1/forecast
      // 一週間より以前だとhttps://archive-api.open-meteo.com/v1/archive
      let domain = 'https://api.open-meteo.com/v1/forecast'
      const now = moment()
      const oneWeekAgo = moment().subtract(7, 'days')
      const isWithinOneWeek = startMomentUtc.isBetween(oneWeekAgo, now, 'day', '[]')
      if (!isWithinOneWeek) {
        domain = 'https://archive-api.open-meteo.com/v1/archive'
      }

      let apiUrl =
        domain +
        '?latitude=' +
        latLon.latitude +
        '&longitude=' +
        latLon.longitude +
        '&start_date=' +
        startDt +
        '&end_date=' +
        startDt +
        '&hourly=temperature_2m,relative_humidity_2m,precipitation,weather_code,wind_speed_10m'
      axios
        .get(apiUrl)
        .then(response => {
          const times = response.data.hourly.time
          const temperature_2m = response.data.hourly.temperature_2m
          const relative_humidity_2m = response.data.hourly.relative_humidity_2m
          const precipitation = response.data.hourly.precipitation
          const weather_code = response.data.hourly.weather_code
          const wind_speed_10m = response.data.hourly.wind_speed_10m
          const targetDt = startMomentUtc.startOf('hour').format('YYYY-MM-DDTHH:mm')
          // 24hから対象の時刻を抽出
          const index = times.findIndex(d => d === targetDt)
          if (index > -1) {
            // OpenMeteoの天気コードをWeathercomの天気コードに変換(icon表示用)
            const openMeteoToWeathercom = {
              '0': '32',
              '1': '32',
              '2': '30',
              '3': '26',
              '45': '20',
              '48': '8',
              '51': '9',
              '53': '9',
              '55': '9',
              '56': '10',
              '57': '10',
              '61': '12',
              '63': '12',
              '65': '40',
              '66': '35',
              '67': '35',
              '71': '16',
              '73': '16',
              '75': '42',
              '77': '16',
              '80': '11',
              '81': '11',
              '82': '40',
              '85': '16',
              '86': '42',
              '95': '3',
              '96': '4',
              '99': '4',
            }

            const icon =
              'https://agri-info-design-public.s3-ap-northeast-1.amazonaws.com/AboutAgriBusConnect/WeathercomIcons/' +
              openMeteoToWeathercom[weather_code[index]] +
              '.png'
            const data = {
              temperature: temperature_2m[index],
              relativeHumidity: relative_humidity_2m[index],
              precipitation: precipitation[index],
              weather_code: weather_code[index],
              windSpeed: wind_speed_10m[index],
              iconUrl: icon,
            }
            commit(Types.SET_CURRENT_TASK_WEATHER_INFO_FROM_OPEN_METEO, data)
          }
        })
        .catch(error => {
          console.error(error)
        })
    }
    // 2024.01.24 OpenMeteo対応により廃止
    // else {
    //   connectGrowClient
    //     .getWeatherInfo(latLon, startMomentUtc)
    //     .then(response => {
    //       const weatherInfo = response.data
    //       commit(Types.SET_CURRENT_TASK_WEATHER_INFO, weatherInfo)
    //     })
    //     .catch(error => {
    //       console.error(error)
    //     })
    // }
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
